import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Sticky } from '../Sticky';
const Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles }, }) => (_jsxs(_Fragment, { children: [_jsx("div", { ...dropzoneProps, children: files.length < maxFiles && input }), previews, _jsx(Sticky, { children: files.length > 0 && submitButton })] }));
export default Layout;
